<script setup>
import { defineProps } from "vue"

import { useRouter } from "vue-router"
import { KNOLIA } from "../knolia";
import NotificationBell from "../components/NotificationBell.vue"

let router = useRouter()

const props = defineProps({
  userStore: {
    type: Object,
    default: Object
  },
})

function ToSkillCard() {
  KNOLIA.SetRequestedUserId(KNOLIA.GetLoggedUserId())
  router.push('/skill-card')
}

function ToRatingSkills() {
  KNOLIA.SetRequestedUserId(KNOLIA.GetLoggedUserId())
  router.push('/rating-skills')
}
</script>

<template>
  <div class="div-container">
    <div class="w-100 row gx-5 justify-content-center buttons align-self-center">
      <div class="col-11 col-md-4">
        <button class="col-12" @click="ToSkillCard()">CÉDULA DE COMPETÊNCIAS</button>
      </div>

      <div class="col-11 col-md-4">
        <button class="col-12 d-flex justify-content-center align-items-center" @click="ToRatingSkills()">
          CLASSIFICAR/ATUALIZAR COMPETÊNCIAS
          <notification-bell :count="props.userStore.CountMessages.rating_skills_message_count" icon="envelope" tooltip="Mensagens não vistas"/>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .div-container {
    margin: 10% auto;
    flex-direction: column;
    display: flex;
  }

  @media screen and (max-width: 767px) {
    .buttons {
      gap: 20px;
    }
  }

</style>
